export const isNullOrUndefined = (e: any): e is null | undefined =>
  e === null || e === undefined;

export const isNotNullOrUndefined = <T>(e: T | null | undefined): e is T =>
  e !== null && e !== undefined;

export const isNotError = <T>(e: T | Error): e is T => !(e instanceof Error);
